// removed by extract-text-webpack-plugin
module.exports = {"container":"I_9xI","itemDescription":"Ls3ca","flexColumn":"_2GAO2","spaceBetween":"nGhnm","meta":"_1T10O nGhnm","itemSummary":"_3P122","thumbnail":"_3dVyB"};